import { render, staticRenderFns } from "./SipServersTable.vue?vue&type=template&id=da85985e&"
import script from "./SipServersTable.vue?vue&type=script&lang=js&"
export * from "./SipServersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports